import { useState } from "react";
import { useDataLoader, AssetService } from "@xala/common-services";
import { NotificationService } from "@xala/common-ui";

const notificationService = NotificationService.getInstance();
const assetService = new AssetService().promisify();

export const usePaymentAssetsDataProvider = () => {
  const [textSearch, setTextSearch] = useState("");
  const { data, loading } = useDataLoader({
    loader: () =>
      assetService.search({
        PageNumber: 1,
        PageSize: 100,
        IncludeCount: false,
        Title: textSearch,
      }),
    onError: (error) =>
      notificationService.error({
        message: error.Title,
        description: error.Message,
      }),
    debounce: 500,
    deps: [textSearch],
  });
  return {
    assets:
      data?.Entities.map((ent) => ({
        key: ent.Id,
        value: ent.Id,
        label: ent.Title,
      })) || [],
    loading,
    setTextSearch,
  };
};
